import React, { useEffect } from 'react';
import { clsx } from 'clsx';
import { useTranslation } from 'react-i18next';
import { useItem, useItemWithdrawFromSale } from '@/hooks/item';
import { ItemWithdrawFromSaleModal } from '@/types/modal';
import { ErrorModal, LoadingBodyModal, StandardModal, SuccessModal } from '@/components/molecules/common/Modal';
import styles from './Modal.module.scss';

const View: React.FC<{ modal: ItemWithdrawFromSaleModal }> = ({ modal }) => {
  const { t } = useTranslation();
  const { item, onClose } = modal;

  const itemR = useItem(item.productId, false);
  const submitR = useItemWithdrawFromSale(item.productId);

  useEffect(() => {
    if (submitR.kind === 'Completed') {
      itemR.refetch();
    }
  }, [submitR.kind]);

  if (submitR.kind === 'Error') {
    return (
      <ErrorModal
        title={t('modal.item_withdraw_from_sale.title')}
        error={submitR.error}
        onClose={onClose}
      />
    );
  } else if (submitR.kind === 'Completed') {
    return (
      <SuccessModal
        title={t('modal.item_withdraw_from_sale.title')}
        onClose={onClose}
      />
    );
  }

  const body =
    submitR.kind === 'Loading' ? (
      <LoadingBodyModal height={40} />
    ) : (
      <>
        <div className={styles.height05rem} />
        <div className={styles.height05rem} />
        <div className={styles.text1rem}>{`${t('modal.update_item_attribute.item')} #${item.productId}`}</div>
        <div className={clsx([styles.text1rem, styles.paddingY1rem])}>{t('modal.item_withdraw_from_sale.body')}</div>
      </>
    );

  return (
    <StandardModal
      title={t('modal.item_withdraw_from_sale.title')}
      onClose={onClose}
      onSubmit={submitR.mutate}
      submitLabel={t('common.submit').toUpperCase()}
      submittable={submitR.kind !== 'Loading'}
      body={body}
      containerStyle={{ width: 400 }}
      modalName="item_withdraw_from_sale"
    />
  );
};

export default View;
